module.exports = __webpack_public_path__ + "media/images/1_clevas_regist_mail_active-736a64bc.png";